var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "aside",
    {
      staticClass: "nti-shop-filter",
      class: { "nti-shop-filter--open": _vm.displayFilters },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "nti-shop-filter__button-container nti-shop-filter__button-container--mobile-filter",
        },
        [
          _c(
            "button",
            {
              staticClass: "nti-button",
              class: { "nti-button--selected": _vm.displayFilters },
              on: { click: _vm.toggleFilters },
            },
            [
              _c(
                "div",
                { staticClass: "nti-svg__container-medium nti-svg--filter" },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 512 512",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M487.976 0H24.028C2.71 0-8.047 25.866 7.058 40.971L192 225.941V432c0 7.831 3.821 15.17 10.237 19.662l80 55.98C298.02 518.69 320 507.493 320 487.98V225.941l184.947-184.97C520.021 25.896 509.338 0 487.976 0z",
                        },
                      }),
                    ]
                  ),
                ]
              ),
              _vm._v(
                "\n            " +
                  _vm._s(_vm.verifyLabel("filterMobileButtonLabel")) +
                  "\n            "
              ),
              _c(
                "div",
                {
                  staticClass: "nti-svg__container-medium nti-svg--drop-down",
                  class: { "nti-svg--drop-down-selected": _vm.displayFilters },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 448 512",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z",
                        },
                      }),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "nti-shop-filter__wrapper",
          class: { "nti-shop-filter__wrapper--open": _vm.displayFilters },
        },
        [
          _c("article", { staticClass: "nti-shop-filter__section" }, [
            _c("h3", { staticClass: "nti-shop-filter__title" }, [
              _vm._v(_vm._s(_vm.verifyLabel("filterHeadingCategoryLabel"))),
            ]),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "nti-shop-filter__level-one" },
              [
                _vm._l(_vm.categories, function (category, index) {
                  return [
                    _c("div", { key: index }, [
                      category.key != "Industry" &&
                      category.key != "Manufacturer" &&
                      category.displayName != "DoNOTShow"
                        ? _c(
                            "article",
                            {
                              staticClass:
                                "nti-shop-filter__level-one__wrapper",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "nti-shop-filter__level-one__label-container",
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: category.selected,
                                        expression: "category.selected",
                                      },
                                    ],
                                    staticClass: "nti-shop-filter__checkbox",
                                    attrs: {
                                      id: `category-level-one-checkbox-id-${category.key}`,
                                      role: "checkbox",
                                      type: "checkbox",
                                      name: category.key,
                                      visible: category.documentCount === 0,
                                    },
                                    domProps: {
                                      checked: Array.isArray(category.selected)
                                        ? _vm._i(category.selected, null) > -1
                                        : category.selected,
                                    },
                                    on: {
                                      change: [
                                        function ($event) {
                                          var $$a = category.selected,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  category,
                                                  "selected",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  category,
                                                  "selected",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(category, "selected", $$c)
                                          }
                                        },
                                        function ($event) {
                                          return _vm.selectFilter(
                                            category.key,
                                            category.value
                                          )
                                        },
                                      ],
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "nti-shop-filter__label",
                                      attrs: {
                                        for: `category-level-one-checkbox-id-${category.key}`,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(category.displayName) +
                                          " (" +
                                          _vm._s(category.documentCount) +
                                          ")"
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(
                                category.facetGroups,
                                function (group, index) {
                                  return [
                                    category.selected
                                      ? _c(
                                          "section",
                                          {
                                            key: index,
                                            staticClass:
                                              "nti-shop-filter__level-two",
                                          },
                                          [
                                            group.displayName
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "nti-shop-filter__level-two__title",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(group.displayName)
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "ul",
                                              {
                                                staticClass:
                                                  "nti-shop-filter__level-two__container",
                                              },
                                              [
                                                _vm._l(
                                                  group.values,
                                                  function (value, index) {
                                                    return [
                                                      _c(
                                                        "li",
                                                        {
                                                          key: index,
                                                          staticClass:
                                                            "nti-shop-filter__level-two__label-container",
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  value.selected,
                                                                expression:
                                                                  "value.selected",
                                                              },
                                                            ],
                                                            staticClass:
                                                              "nti-shop-filter__checkbox",
                                                            attrs: {
                                                              id: `category-level-two-checkbox-id-${value.key}`,
                                                              role: "checkbox",
                                                              type: "checkbox",
                                                              name: value.key,
                                                              disabled:
                                                                value.documentCount ===
                                                                0,
                                                            },
                                                            domProps: {
                                                              checked:
                                                                Array.isArray(
                                                                  value.selected
                                                                )
                                                                  ? _vm._i(
                                                                      value.selected,
                                                                      null
                                                                    ) > -1
                                                                  : value.selected,
                                                            },
                                                            on: {
                                                              change: [
                                                                function (
                                                                  $event
                                                                ) {
                                                                  var $$a =
                                                                      value.selected,
                                                                    $$el =
                                                                      $event.target,
                                                                    $$c =
                                                                      $$el.checked
                                                                        ? true
                                                                        : false
                                                                  if (
                                                                    Array.isArray(
                                                                      $$a
                                                                    )
                                                                  ) {
                                                                    var $$v =
                                                                        null,
                                                                      $$i =
                                                                        _vm._i(
                                                                          $$a,
                                                                          $$v
                                                                        )
                                                                    if (
                                                                      $$el.checked
                                                                    ) {
                                                                      $$i < 0 &&
                                                                        _vm.$set(
                                                                          value,
                                                                          "selected",
                                                                          $$a.concat(
                                                                            [
                                                                              $$v,
                                                                            ]
                                                                          )
                                                                        )
                                                                    } else {
                                                                      $$i >
                                                                        -1 &&
                                                                        _vm.$set(
                                                                          value,
                                                                          "selected",
                                                                          $$a
                                                                            .slice(
                                                                              0,
                                                                              $$i
                                                                            )
                                                                            .concat(
                                                                              $$a.slice(
                                                                                $$i +
                                                                                  1
                                                                              )
                                                                            )
                                                                        )
                                                                    }
                                                                  } else {
                                                                    _vm.$set(
                                                                      value,
                                                                      "selected",
                                                                      $$c
                                                                    )
                                                                  }
                                                                },
                                                                function (
                                                                  $event
                                                                ) {
                                                                  return _vm.selectFilter(
                                                                    group.key,
                                                                    value.key
                                                                  )
                                                                },
                                                              ],
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "nti-shop-filter__label",
                                                              attrs: {
                                                                for: `category-level-two-checkbox-id-${value.key}`,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  value.displayName
                                                                ) +
                                                                  " (" +
                                                                  _vm._s(
                                                                    value.documentCount
                                                                  ) +
                                                                  ")"
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                }
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                    ]),
                  ]
                }),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _vm._l(_vm.categories, function (category, index) {
            return [
              category.key === "Industry" && category.documentCount != 0
                ? _c(
                    "article",
                    { key: index, staticClass: "nti-shop-filter__section" },
                    [
                      _c("h3", { staticClass: "nti-shop-filter__title" }, [
                        _vm._v(
                          _vm._s(_vm.verifyLabel("filterHeadingIndustryLabel"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "section",
                        { staticClass: "nti-shop-filter__level-one" },
                        [
                          _vm._l(category.facetGroups, function (group, index) {
                            return [
                              _c(
                                "ul",
                                {
                                  key: index,
                                  staticClass:
                                    "nti-shop-filter__level-two__container nti-shop-filter__level-two__container--no-sub-header",
                                },
                                [
                                  _vm._l(group.values, function (value, index) {
                                    return [
                                      _c(
                                        "li",
                                        {
                                          key: index,
                                          staticClass:
                                            "nti-shop-filter__level-two__label-container",
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: value.selected,
                                                expression: "value.selected",
                                              },
                                            ],
                                            staticClass:
                                              "nti-shop-filter__checkbox",
                                            attrs: {
                                              id: `industry-checkbox-id-${index}`,
                                              role: "checkbox",
                                              type: "checkbox",
                                              name: value.key,
                                              disabled:
                                                value.documentCount === 0,
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                value.selected
                                              )
                                                ? _vm._i(value.selected, null) >
                                                  -1
                                                : value.selected,
                                            },
                                            on: {
                                              change: [
                                                function ($event) {
                                                  var $$a = value.selected,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        _vm.$set(
                                                          value,
                                                          "selected",
                                                          $$a.concat([$$v])
                                                        )
                                                    } else {
                                                      $$i > -1 &&
                                                        _vm.$set(
                                                          value,
                                                          "selected",
                                                          $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            )
                                                        )
                                                    }
                                                  } else {
                                                    _vm.$set(
                                                      value,
                                                      "selected",
                                                      $$c
                                                    )
                                                  }
                                                },
                                                function ($event) {
                                                  return _vm.selectFilter(
                                                    group.key,
                                                    value.key
                                                  )
                                                },
                                              ],
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "nti-shop-filter__label",
                                              attrs: {
                                                for: `industry-checkbox-id-${index}`,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(value.displayName) +
                                                  " (" +
                                                  _vm._s(value.documentCount) +
                                                  ")"
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  }),
                                ],
                                2
                              ),
                            ]
                          }),
                        ],
                        2
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          }),
          _vm._v(" "),
          _vm._l(_vm.categories, function (category, index) {
            return [
              category.key === "Manufacturer" && category.documentCount != 0
                ? _c(
                    "article",
                    { key: index, staticClass: "nti-shop-filter__section" },
                    [
                      _c("h3", { staticClass: "nti-shop-filter__title" }, [
                        _vm._v(
                          _vm._s(
                            _vm.verifyLabel("filterHeadingManufacturerLabel")
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "section",
                        { staticClass: "nti-shop-filter__level-one" },
                        [
                          _vm._l(category.facetGroups, function (group, index) {
                            return [
                              _c(
                                "ul",
                                {
                                  key: index,
                                  staticClass:
                                    "nti-shop-filter__level-two__container nti-shop-filter__level-two__container--no-sub-header",
                                },
                                [
                                  _vm._l(group.values, function (value, index) {
                                    return [
                                      _c(
                                        "li",
                                        {
                                          key: index,
                                          staticClass:
                                            "nti-shop-filter__level-two__label-container",
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: value.selected,
                                                expression: "value.selected",
                                              },
                                            ],
                                            staticClass:
                                              "nti-shop-filter__checkbox",
                                            attrs: {
                                              id: `manufacturer-checkbox-id-${value.key}`,
                                              role: "checkbox",
                                              type: "checkbox",
                                              name: value.key,
                                              disabled:
                                                value.documentCount === 0,
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                value.selected
                                              )
                                                ? _vm._i(value.selected, null) >
                                                  -1
                                                : value.selected,
                                            },
                                            on: {
                                              change: [
                                                function ($event) {
                                                  var $$a = value.selected,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        _vm.$set(
                                                          value,
                                                          "selected",
                                                          $$a.concat([$$v])
                                                        )
                                                    } else {
                                                      $$i > -1 &&
                                                        _vm.$set(
                                                          value,
                                                          "selected",
                                                          $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            )
                                                        )
                                                    }
                                                  } else {
                                                    _vm.$set(
                                                      value,
                                                      "selected",
                                                      $$c
                                                    )
                                                  }
                                                },
                                                function ($event) {
                                                  return _vm.selectFilter(
                                                    group.key,
                                                    value.key
                                                  )
                                                },
                                              ],
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "nti-shop-filter__label",
                                              attrs: {
                                                for: `manufacturer-checkbox-id-${value.key}`,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(value.displayName) +
                                                  " (" +
                                                  _vm._s(value.documentCount) +
                                                  ")"
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  }),
                                ],
                                2
                              ),
                            ]
                          }),
                        ],
                        2
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          }),
          _vm._v(" "),
          _c("div", { staticClass: "nti-shop-filter__button-container" }, [
            _c(
              "button",
              { staticClass: "nti-button", on: { click: _vm.clearFilters } },
              [_vm._v(_vm._s(_vm.verifyLabel("clearFilterLabel")))]
            ),
          ]),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }